import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Global from "./Global";

const rootElement = document.querySelector("#root");

fetch(Global.BASE_URL + "api/config")
  .then((res) => res.json())
  .then((config) => {
    if (config.BASE_URL) Global.BASE_URL = config.BASE_URL;
    if (config.REPORT_URL) Global.REPORT_URL = config.REPORT_URL;
  })
  .catch((err) => {
    console.error("Failed to load config from backend, using defaults:", err);
  })
  .finally(() => {
    ReactDOM.render(<App />, rootElement);
  });